// pages/devolucionesCompra/DevolucionCompraForm.tsx
import PageLayout from "../../components/layout/PageLayout";
import AssignmentReturnIcon from "@mui/icons-material/AssignmentReturn";
import DevolucionCompraFormContent from "../../components/DevolucionCompra/DevolucionCompraForm";

const DevolucionCompraForm = () => {
  return (
    <PageLayout 
      icon={AssignmentReturnIcon} 
      title="Nueva Devolución de Compra"
    >
      <DevolucionCompraFormContent />
    </PageLayout>
  );
};

export default DevolucionCompraForm;